import { defineComponent as r, openBlock as l, createBlock as a, unref as p, mergeProps as m, withCtx as u, createElementVNode as o } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconDoubleChevronUp",
  __name: "IconDoubleChevronUp",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (s, e) => (l(), a(p(c), m(n, { "view-box": "0 0 24 24" }), {
      default: u(() => [...e[0] || (e[0] = [
        o("path", { d: "M15.47 12.177 12 8.707l-3.47 3.47a.75.75 0 1 1-1.06-1.06l3.646-3.647a1.25 1.25 0 0 1 1.768 0l3.646 3.646a.75.75 0 0 1-1.06 1.06" }, null, -1),
        o("path", { d: "M15.47 16.677 12 13.207l-3.47 3.47a.75.75 0 1 1-1.06-1.06l3.646-3.647a1.25 1.25 0 0 1 1.768 0l3.646 3.646a.75.75 0 0 1-1.06 1.06" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
